import { useEffect, useState } from 'react';
import { useEmployee } from './EmployeeContext';
import { useModal } from '../../components/ModalProvider';
import { useEnsureOnboarding } from './onboarding/useEnsureOnboarding';
import { employeeApi } from '../../lib/api';
import { todayStr, nowISO, fmtHM, fmtDateBR } from '../../lib/format';
import { capturePhoto, deviceMeta, tryGetIP, getCurrentPosition, geoPreCheckMessage, geoErrorMessage, urlToDataUrl } from '../../lib/photo';
import { generateReceiptPDF } from '../../lib/pdf';
import { ErrorModalBody } from '../../components/ErrorModalBody';

export function AlimentacaoTab() {
  const { employee } = useEmployee();
  const { showModal, closeModal } = useModal();
  const runGated = useEnsureOnboarding();
  const [rec, setRec] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const date = todayStr();

  async function reload() {
    const res = await employeeApi.getValeAlim(date);
    setRec(res.record || null);
  }
  useEffect(() => { setLoading(true); reload().finally(() => setLoading(false)); }, []);

  function registrar() {
    runGated(() => {
      showModal(<div style={{ textAlign: 'center', padding: '20px 0' }}>
        <p className="muted">Vamos confirmar sua localização e depois tirar uma selfie — ambas obrigatórias.</p>
        <button className="btn btn-primary btn-block" onClick={startFlow}>Continuar</button>
        <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={closeModal}>Cancelar</button>
      </div>);
    });
  }

  function startFlow() {
    const geoMsg = geoPreCheckMessage();
    if (geoMsg) {
      showModal(<><h2 style={{ color: 'var(--coral)' }}>Localização indisponível</h2><p className="muted">{geoMsg}</p><button className="btn btn-ghost btn-block" onClick={closeModal}>Entendi</button></>);
      return;
    }
    showModal(<div style={{ textAlign: 'center', padding: '20px 0' }}><p className="muted">Obtendo localização…</p></div>);
    getCurrentPosition().then((pos) => {
      const lat = pos.coords.latitude, lng = pos.coords.longitude, accuracy = Math.round(pos.coords.accuracy);
      showModal(<div style={{ textAlign: 'center', padding: '16px 0' }}>
        <p className="muted">Localização confirmada. Agora tire uma selfie para confirmar sua identidade — é obrigatória para concluir o registro.</p>
        <button className="btn btn-primary btn-block" onClick={() => finishPhoto(lat, lng, accuracy)}>Tirar selfie</button>
        <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={closeModal}>Cancelar</button>
      </div>);
    }).catch((err) => {
      showModal(<>
        <h2 style={{ color: 'var(--coral)' }}>Não foi possível obter a localização</h2>
        <p className="muted">{geoErrorMessage(err)}</p>
        <button className="btn btn-primary btn-block" onClick={startFlow}>Tentar novamente</button>
        <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={closeModal}>Fechar</button>
      </>);
    });
  }

  async function finishPhoto(lat: number, lng: number, accuracy: number) {
    try {
      showModal(<div style={{ textAlign: 'center', padding: '20px 0' }}><p className="muted">Abrindo câmera…</p></div>);
      const meta = [employee.nome, `Vale-alimentação — ${new Date().toLocaleString('pt-BR')}`, `Lat ${lat.toFixed(5)}, Lng ${lng.toFixed(5)}`];
      const photo = await capturePhoto('user', meta);
      if (!photo) {
        showModal(<><h2 style={{ color: 'var(--coral)' }}>Foto obrigatória</h2><p className="muted">Não foi possível registrar sem a selfie. Tente novamente.</p><button className="btn btn-ghost btn-block" onClick={closeModal}>Fechar</button></>);
        return;
      }
      const ip = await tryGetIP();
      await employeeApi.registrarValeAlim({ hora: nowISO(), lat, lng, accuracy, foto: photo, ip, device: deviceMeta() });
      closeModal();
      await reload();
    } catch (err) {
      showModal(<ErrorModalBody error={err} onClose={closeModal} onRetry={() => finishPhoto(lat, lng, accuracy)} />);
    }
  }

  async function downloadPDF() {
    if (!rec) return;
    const foto = rec.fotoUrl ? await urlToDataUrl(rec.fotoUrl) : null;
    generateReceiptPDF('Comprovante de Vale-Alimentação', employee, {
      Data: fmtDateBR(date),
      Hora: fmtHM(rec.hora),
      Localização: rec.lat ? `${rec.lat}, ${rec.lng}` : '—',
      'Verificação em cadeia': (rec.hashAnterior || '').slice(0, 20) + '…',
    }, foto, rec.hash);
  }

  if (loading) return <div className="card"><p className="muted">Carregando…</p></div>;

  return (
    <div className="card">
      <h2>Vale-alimentação</h2>
      <p className="hint">Registro de hoje, {fmtDateBR(date)}.</p>
      {rec ? (
        <>
          <div className="pill pill-ok">✓ registrado às {fmtHM(rec.hora)}</div>
          <button className="btn btn-ghost btn-sm btn-block" style={{ marginTop: 10 }} onClick={downloadPDF}>Baixar comprovante</button>
        </>
      ) : (
        <button className="btn btn-teal btn-block" onClick={registrar}>Registrar vale-alimentação de hoje</button>
      )}
    </div>
  );
}
